export default function user(nav) {
  if (localStorage.getItem("token") === null) {
    return (window.location.href = "/login");
  } else {
    return nav.next();
  }
}
